import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import NotFound from "./NotFound";

const AdminProtectedRoute = ({ children }) => {
  const isAdmin = sessionStorage.getItem("isAdmin"); // "true" / "false"
  const location = useLocation();

  // Admin only allowed:
  const adminAllowedRoutes = ["/merchant-list"];

  // Not logged in
  if (!sessionStorage.getItem("name")) {
    return <Navigate to="/login" replace />;
  }

  // If user is NOT admin → block route
  if (isAdmin !== "true") {
    return <NotFound />;
  }

  // Admin attempting to access a non-admin route → block
  if (!adminAllowedRoutes.includes(location.pathname)) {
    return <NotFound />;
  }

  return children;
};

export default AdminProtectedRoute;
